import { Trans, useTranslation } from 'react-i18next';

import Typography from '../../../../components/Typography';
import { HomeTabs } from '../../../../home/store/types';
import { i18nNS } from '../../../../i18n';
import { PlusIcon } from './styles';
import useMessage from './vm';

const Message = () => {
  const { t } = useTranslation([i18nNS.COURSES]);

  const { canCreateCourses, activeTab, hasOngoingCourses, hasPastCourses, hasArchivedCourses } = useMessage();

  if (activeTab === HomeTabs.ONGOING_COURSES) {
    if (hasOngoingCourses) return null;

    if (canCreateCourses) {
      if (!hasPastCourses) {
        return (
          <Typography variant="h5Medium" color="grey.500" component="div">
            <Trans
              t={t}
              ns={i18nNS.COURSES}
              i18nKey="to_get_started_click_on_the_plus_button_at_the_bottom_right_to_create_a_new_course_or_join_an_existing_course_as_a_student"
            >
              To get started, click on the <PlusIcon /> button at the bottom right to create a new course or
              join an existing course as a student.
            </Trans>
          </Typography>
        );
      }

      if (!hasArchivedCourses) {
        return (
          <Typography variant="h5Medium" color="grey.500" component="div">
            <p>{t('you_are_not_enrolled_in_any_ongoing_courses', { ns: i18nNS.COURSES })}</p>
            <p>
              <Trans
                t={t}
                ns={i18nNS.COURSES}
                i18nKey="you_can_access_your_completed_courses_in_the_past_courses_tab_or_you_can_tap_on_the_plus_button_at_the_bottom_right_to_create_a_new_course_or_join_an_ongoing_course_as_a_student"
              >
                You can access your completed courses in the "Past courses" tab. Or you can tap on the{' '}
                <PlusIcon /> button at the bottom right to create a new course or join an ongoing course as a
                student.
              </Trans>
            </p>
          </Typography>
        );
      }

      return (
        <Typography variant="h5Medium" color="grey.500" component="div">
          <p>{t('you_are_not_enrolled_in_any_ongoing_courses', { ns: i18nNS.COURSES })}</p>
          <p>
            <Trans
              t={t}
              ns={i18nNS.COURSES}
              i18nKey="you_can_access_your_completed_and_archived_courses_in_the_past_courses_tab_or_you_can_tap_on_the_plus_button_at_the_bottom_right_to_create_a_new_course_or_join_an_ongoing_course_as_a_student"
            >
              You can access your completed and archived courses in the \"Past courses\" tab. Or you can tap
              on the <PlusIcon /> button at the bottom right to create a new course or join an ongoing course
              as a student.
            </Trans>
          </p>
        </Typography>
      );
    }

    if (!hasPastCourses) {
      return (
        <Typography variant="h5Medium" color="grey.500" component="div">
          <p>{t('you_are_not_enrolled_in_any_ongoing_courses', { ns: i18nNS.COURSES })}</p>
          <p>
            <Trans
              t={t}
              ns={i18nNS.COURSES}
              i18nKey="you_can_join_an_ongoing_course_as_a_student_by_tapping_on_the_plus_button"
            >
              You can join an ongoing course as a student by tapping on the <PlusIcon /> button.
            </Trans>
          </p>
        </Typography>
      );
    }

    if (!hasArchivedCourses) {
      return (
        <Typography variant="h5Medium" color="grey.500" component="div">
          <p>{t('you_are_not_enrolled_in_any_ongoing_courses', { ns: i18nNS.COURSES })}</p>
          <p>
            <Trans
              t={t}
              ns={i18nNS.COURSES}
              i18nKey="you_can_access_your_completed_courses_in_the_past_courses_tab_you_can_also_join_an_ongoing_course_as_a_student_by_tapping_on_the_plus_button"
            >
              You can access your completed courses in the \"Past courses\" tab. You can also join an ongoing
              course as a student by tapping on the <PlusIcon /> button.
            </Trans>
          </p>
        </Typography>
      );
    }

    return (
      <Typography variant="h5Medium" color="grey.500" component="div">
        <p>{t('you_are_not_enrolled_in_any_ongoing_courses', { ns: i18nNS.COURSES })}</p>
        <p>
          <Trans
            t={t}
            ns={i18nNS.COURSES}
            i18nKey="you_can_access_your_completed_and_archived_courses_in_the_past_courses_tab_you_can_also_join_an_ongoing_course_as_a_student_by_tapping_on_the_plus_button"
          >
            You can access your completed and archived courses in the \"Past courses\" tab. You can also join
            an ongoing course as a student by tapping on the <PlusIcon /> button.
          </Trans>
        </p>
      </Typography>
    );
  }

  if (activeTab === HomeTabs.PAST_COURSES) {
    if (hasPastCourses) return null;
    return (
      <Typography variant="h5Medium" color="grey.500">
        {t(
          'either_you_were_not_enrolled_in_any_courses_in_the_past_or_the_courses_have_been_removed_or_archived',
          { ns: i18nNS.COURSES }
        )}
      </Typography>
    );
  }

  return null;
};

export default Message;
